<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 6L7.5 10.5L12 6" stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
